<div class="panel panel-default">
  <div class="panel-body">
    <!--Initial satisfaction response options-->
    <div *ngIf="showSatisfactionOptions" class="text-center">
      <h5>{{ 'SATISFACTION_EXPLANATION' | translate }}</h5>
      <button
        id="setSatisfaction2"
        (click)="setSatisfaction(2)"
        class="btn btn-info btn-satisfaction"
        [class.active]="value.satisfaction === 2"
        [disabled]="isLoading"
      >
        {{ 'REVIEW_SATISFACTION_LEVEL_2' | translate }}
        <div>😍</div>
      </button>
      <button
        id="setSatisfaction1"
        (click)="setSatisfaction(1)"
        class="btn btn-info btn-satisfaction"
        [class.active]="value.satisfaction === 1"
        [disabled]="isLoading"
      >
        {{ 'REVIEW_SATISFACTION_LEVEL_1' | translate }}
        <div>😏</div>
      </button>
      <button
        id="setSatisfaction0"
        (click)="setSatisfaction(0)"
        class="btn btn-info btn-satisfaction"
        [class.active]="value.satisfaction === 0"
        [disabled]="isLoading"
      >
        {{ 'REVIEW_SATISFACTION_LEVEL_0' | translate }}
        <div>😕</div>
      </button>
    </div>

    <!--Feedback form-->
    <div *ngIf="showFeedbackForm">
      <p>{{ 'BAD_EXPERIENCE' | translate }}</p>

      <textarea
        class="form-control"
        [(ngModel)]="feedback"
        [placeholder]="'HOW_CAN_WE_IMPROVE' | translate"
        rows="5"
        style="overflow: auto; resize: none"
      ></textarea>

      <button id="submitFeedback" class="btn btn-primary mt-2" (click)="submitFeedback()">
        {{ 'SUBMIT_FEEDBACK' | translate }}
      </button>
    </div>

    <!-- External review -->
    <div *ngIf="showExternalReview">
      <!-- <h5>{{ 'HELP_OTHER_TRAVELERS' | translate }}</h5> -->
      <h5>{{ 'HELP_OTHER_TRAVELERS' | translate }}</h5>
      <div *ngIf="externalReviewPlatform">
        <!-- <span>{{ 'LEAVE_A_REVIEW_OF' | translate }} {{ booking.shopName }} {{ 'ON_PLATFORM' | translate }}&nbsp;</span> -->
        <span>{{ 'RATE_LUGGAGEHERO' | translate }} {{ 'ON_PLATFORM' | translate }}&nbsp;</span>
        <a id="goToExternalReview" class="href" [href]="externalReviewUrl" target="_blank">{{
          externalReviewPlatform
        }}</a>
      </div>
    </div>

    <div *ngIf="!showExternalReview">
      <!--Leave a review button-->
      <button id="requestLeaveReview" *ngIf="showReviewButton" class="btn btn-default" (click)="requestReview()">
        {{ 'LEAVE_A_REVIEW' | translate }}
      </button>

      <!--Review form-->
      <div *ngIf="showEditableReview">
        <div>
          <div class="form-group">{{ 'RATING_EXPLANATION' | translate }}</div>
          <div>
            <rating class="shop-rating-lg" [(ngModel)]="rating" [readonly]="false"></rating>
          </div>
        </div>
        <div *ngIf="value.rating" class="review">
          <label>{{ 'REVIEW_EXPLANATION' | translate }}</label>
          <div class="form-group">
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="value.headline"
              [placeholder]="'REVIEW_HEADLINE' | translate"
            />
          </div>
          <div class="form-group">
            <textarea
              class="form-control"
              [(ngModel)]="value.shopComments"
              [placeholder]="'REVIEW_SHOP_COMMENTS_OPTIONAL' | translate"
              rows="5"
              style="overflow: auto; resize: none"
            ></textarea>
          </div>
          <!--<div class="form-group">
            <textarea class="form-control" [(ngModel)]="value.areaComments" [placeholder]="'REVIEW_AREA_COMMENTS_OPTIONAL' | translate" rows="3" style="overflow:auto;resize:none"></textarea>
          </div>-->
          <button
            id="publishReview"
            class="btn btn-warning"
            [disabled]="!value.headline || value.headline.trim() === ''"
            (click)="publishReview()"
          >
            {{ 'PUBLISH_REVIEW' | translate }}
          </button>
        </div>
      </div>

      <!--Published review in read-only mode-->
      <div *ngIf="showReadOnlyReview">
        <rating class="shop-rating-lg" [(ngModel)]="rating" [readonly]="true"></rating>
        <h5>{{ value.headline }}</h5>
        <div class="comments">{{ value.shopComments }}</div>
        <!--<div>{{'REVIEW_SHOP_COMMENTS' | translate}}: {{value.shopComments}}</div>-->
        <!--<div>{{'REVIEW_AREA_COMMENTS' | translate}}: {{value.areaComments}}</div>-->
        <div class="pull-right">
          <button id="editExistingReview" class="btn btn-default" (click)="startEditing()">
            {{ 'EDIT' | translate }}
          </button>
          <button id="doneWithExistingReview" class="btn btn-primary" (click)="done.next()">
            {{ 'DONE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
